<template>
  <px-lateral-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             v-on="on">
        <v-icon>mdi-plus</v-icon>
        Fornecedor
      </v-btn>
    </template>
    <template v-slot:title>
      Adicionar fornecedor
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <px-autocomplete-fornecedor dense
                                      v-model="fornecedor"
                                      class="required rounded-tag-small"
                                      :error="$v.fornecedor.$error"
                                      @blur="$v.fornecedor.$touch()"
                                      required/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn text class="normal-btn-text" @click="close">
        Fechar
      </v-btn>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small"
             :loading="loading"
             :disabled="$v.$invalid"
             @click="onClickSave">
        Salvar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import GestaoFornecedorService from './gestao-fornecedor-service';

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      fornecedor: null,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    onClickSave() {
      this.loading = true;
      GestaoFornecedorService.create({
        fornecedor: this.fornecedor,
      })
        .then(({ data }) => {
          this.close();
          this.$toast('Fornecedor criado', { color: 'success' });
          this.$router.push({
            name: 'main.gestao-fornecedores.fornecedor',
            params: {
              id: data.id,
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  validations: {
    fornecedor: {
      required,
    },
  },
};
</script>
